// extracted by mini-css-extract-plugin
module.exports = {"allocationsList":"AllocationsList_allocationsList__wrXtb","wrap":"AllocationsList_wrap__1dnJ0","allocationsListItem":"AllocationsList_allocationsListItem__3djOM"};